import { render } from "./PermissionsBox.vue?vue&type=template&id=bf3c2bfe"
import script from "./PermissionsBox.vue?vue&type=script&lang=js"
export * from "./PermissionsBox.vue?vue&type=script&lang=js"

import exportComponent from "/home/adssilicondigital/ads.silicon.digital/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__